import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/catalogue.service';



export const listCatalogue = createAsyncThunk(
    "Catalogue/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterCatalogue = createAsyncThunk(
    "Catalogue/adm-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const superFilterCatalogue = createAsyncThunk(
    "Catalogue/adm-super-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.superFilterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listSettings = createAsyncThunk(
    "Catalogue-setting/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getSettings(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createSetting = createAsyncThunk(
    "Catalogue-setting/adm-createSetting",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createSetting(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const deleteSetting = createAsyncThunk(
    "Catalogue-setting/adm-removeSetting",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removeSetting(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewCatalogue = createAsyncThunk(
    "Catalogue/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const searchPublicBySKU = createAsyncThunk(
    "Catalogue/adm-search",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.searchPublicBySKU(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getNextSku = createAsyncThunk(
    "Catalogue/adm-getNextSku",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getNextSku(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createCatalogue = createAsyncThunk(
    "Catalogue/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createManyCatalogue = createAsyncThunk(
    "Catalogue/adm-create-many",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createMany(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCatalogue = createAsyncThunk(
    "Catalogue/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteCatalogue = createAsyncThunk(
    "Catalogue/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const uploadAfficheCatalogue = createAsyncThunk(
    "Catalogue/adm-uploadAffiche",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.uploadAffiche(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const uploadPhotosCatalogue = createAsyncThunk(
    "Catalogue/adm-uploadPhotos",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.uploadPhotos(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const removePhotoCatalogue = createAsyncThunk(
    "Catalogue/adm-removePhoto",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removePhoto(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const createCM = createAsyncThunk(
    "Catalogue/adm-createCM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createCM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCM = createAsyncThunk(
    "Catalogue/adm-updateCM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateCM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteCM = createAsyncThunk(
    "Catalogue/adm-removeCM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removeCM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createDmdReassort = createAsyncThunk(
    "Catalogue/adm-createDmdReassort",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createDmdReassort(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateDmdReassort = createAsyncThunk(
    "Catalogue/adm-updateDmdReassort",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateDmdReassort(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const listDmdReassort = createAsyncThunk(
    "Catalogue/adm-listDmdReassort",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listDmdReassort(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const listOpenDmdReassort = createAsyncThunk(
    "Catalogue/adm-listOpenDmdReassort",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listOpenDmdReassort(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)


export const createGroupeModel = createAsyncThunk(
    "Catalogue/adm-createGroupeModel",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createGroupeModel(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const updateGroupeModel = createAsyncThunk(
    "Catalogue/adm-updateGroupeModel",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateGroupeModel(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const listGroupeModel = createAsyncThunk(
    "Catalogue/adm-listGroupeModel",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listGroupeModel(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const deleteGroupeModel = createAsyncThunk(
    "Catalogue/adm-removeGroupeModel",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removeGroupeModel(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)


export const initCoursMetaux = createAsyncThunk(
    "Catalogue/adm-initCoursMetaux",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.initCoursMetaux(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const updateCoursMetaux = createAsyncThunk(
    "Catalogue/adm-updateCoursMetaux",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateCoursMetaux(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const listCoursMetaux = createAsyncThunk(
    "Catalogue/adm-listCoursMetaux",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listCoursMetaux(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)


export const getUtilsSettings = createAsyncThunk(
    "Catalogue/adm-getUtilsSettings",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getUtilsSettings(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const createUtilsSetting = createAsyncThunk(
    "Catalogue/adm-createUtilsSetting",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createUtilsSetting(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)

export const removeUtilsSetting = createAsyncThunk(
    "Catalogue/adm-removeUtilsSetting",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removeUtilsSetting(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
   
    }
)




const initialState = {
    loading: false,
    error: '',
    sel_Catalogue: null
}

const CatalogueSlice = createSlice({
    name: "Catalogue",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = CatalogueSlice;
export const { clear } = CatalogueSlice.actions;
export default reducer;